import request from "@utils/request";
import { fromData } from "@utils/util";
import { stringify } from "qs";
import { BASEUPLOADURL, BASEURL, MockUrl } from "../baseUrl";
import { headers } from "../login";
import {message} from "antd";

// const BASEURL = ''

/****************身份要素类核验******************/
// 身份证二要素
export const idCard2elements  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/idCard2elements`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 手机号二要素
export const mobile2elements  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/mobile2elements`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 手机号三要素
export const mobile3elements  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/mobile3elements`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 银行卡二要素
export const bankCard2elements  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/bankCard2elements`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 银行卡三要素
export const bankCard3elements  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/bankCard3elements`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 银行卡四要素
export const bankCard4elements  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/bankCard4elements`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 工商企业四要素
export const ent4elements  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/ent4elements`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 人车核验
export const peopleCarMatch  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/peopleCarMatch`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 号码在网时长
export const onlineTime  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/onlineTime`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 号码活跃度
export const activeCheck  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/activeCheck`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 携号转网查询
export const numberPortability  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/numberPortability`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 身份证有效期核验
export const personal  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/personal`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 银行卡归属地
export const bankCardInfo  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/bankCardInfo`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 风险号检测
export const forbidCheck  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/forbidCheck`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 反欺诈羊毛盾
export const woolTag  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/woolTag`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    // @ts-ignore
    message.success(res.data || '操作成功');
    return res;
}
// 人像比对
export const photomatch  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/photomatch`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    return res;
}
// 静态活体检测
export const staticFaceCheck  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/staticFaceCheck`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    return res;
}
// 动态活体检测
export const dynamicFaceCheck  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/dynamicFaceCheck`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    return res;

}
// 人脸照片核验
export const faceImageMatch  = async (data?: object) => {
    const res = await request({
        url:`${BASEURL}/web/onlineCheck/faceImageMatch`,
        // headers,
        data: fromData({ ...data})
    })
    // @ts-ignore
    if (res?.code !== 200) {
        // @ts-ignore
        return Promise.reject(new Error(res.msg));
    }
    return res;

}